import InputField from '@cube3/cubicle/src/core/atoms/InputField/InputField';
import React, { useState } from 'react';
import { useGenerateImage } from './hooks/useGenerateImage';
import Button from '@cube3/cubicle/src/core/atoms/Button/Button';
import { useModalActions } from '../Modals/modalActions';
import { ModalWindowUI } from '@cube3/ui/src/Modal/ModalWindowUI';
import { HBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { ReviewViewTemplate } from '@cube3/cubicle/src/core/templates/ReviewViewTemplate';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import { useDeferredSearchQuery } from './hooks/useDeferredSearchQuery';
import { SearchResult } from './prefabs/SearchResult';
import { GenerativeContextProvider } from './contexts/GenerativeContext';
import { GenerationViewer } from './prefabs/GenerationViewer';
import { FolderContent } from './prefabs/FolderContent';
import { Scrollbar } from '@cube3/cubicle/src/core/atoms/Scrollbar';
import { PromptInput } from './prefabs/PromptInput';
import { GenerationHistory } from './prefabs/GenerationHistory';

interface Props {
  // if should show the folder navigation section
  modalContext: boolean;
}

export const GenerationModal = ({
  modalContext: withBaseImage = true
}: Props) => {
  const { search, query, setSearch } = useDeferredSearchQuery();

  const { previousModal } = useModalActions();

  const { generation, onGenerate, loading, error, setError } =
    useGenerateImage();

  const [openSideBar, setOpenSideBar] = useState(withBaseImage);

  return (
    <ModalWindowUI hideHeader={true} onCloseEvent={previousModal}>
      <GenerativeContextProvider>
        <ReviewViewTemplate
          openSideBar={openSideBar}
          setOpenSideBar={setOpenSideBar}
          drawerWidth={512}
          HeaderComponent={
            <HBox align="center" style={{ paddingTop: 12 }}>
              <Typography>Generate with AI...</Typography>

              <Button iconLeft="close" onClick={previousModal} />
            </HBox>
          }
          NaviComponent={
            withBaseImage ? (
              <section
                id="generative_naviComponent"
                style={{ height: 'calc(100% - 96px)', padding: '16px 0' }}
              >
                <Scrollbar>
                  {!search ? (
                    <FolderContent />
                  ) : query === search.trim() ? (
                    <SearchResult query={query} disableNavigation />
                  ) : null}
                </Scrollbar>
              </section>
            ) : null
          }
          SideBarHeader={
            <HBox align="center" gap={8}>
              <InputField
                placeholder="Search for images in entire workspace..."
                value={search}
                onChange={setSearch}
                multiline={1}
                iconLeft="search"
              />

              <span
                style={{
                  visibility: search ? 'visible' : 'hidden',
                  pointerEvents: search ? 'initial' : 'none'
                }}
              >
                <Button
                  onClick={() => setSearch('')}
                  label="Clear"
                  background="secondary"
                  buttonStyle="ghost"
                />
              </span>
            </HBox>
          }
          MainComponent={
            <>
              <GenerationViewer
                error={error}
                setError={setError}
                loading={loading}
                withBaseImage={withBaseImage}
              />
              <PromptInput
                onGenerate={onGenerate}
                generation={generation}
                loading={loading}
                error={error}
              />
            </>
          }
        />
      </GenerativeContextProvider>
    </ModalWindowUI>
  );
};
// Describe what you want to change
